export default `
<script src="https://ymatuhin.ru/ads/ads.js" defer></script>
<div data-ads></div>
`;
